import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { AuthenticationLocalService } from '../../../../../features/authentication/data/data_source/local/authentication_local_service';
import { UserLocalService } from '../../data/data_source/local/user_local_service';
import { AuthRepositoryImpl } from '../../../../../features/profile/data/repository/auth_repository_impl';
import { useNavigate } from 'react-router-dom';

export const useLogout = () => {
  const queryClient = useQueryClient();
  const authLocalService = new AuthenticationLocalService();
  const userLocalService = new UserLocalService();
  const repository = new AuthRepositoryImpl();
  const navigate = useNavigate();

  const logoutLocal = () => {
    authLocalService.removeAccessToken();
    authLocalService.removeRefreshToken();
    
    userLocalService.removeMeCached();
    
    queryClient.clear();

    navigate("/welcome");
  };

  const logoutMutation = useMutation<void, AxiosError, void>({
    mutationFn: () => repository.logout(),
    onSettled: () => {
      logoutLocal();
    },
  });

  return { 
    logoutLocal,
    ...logoutMutation
  };
};
